module.exports = __webpack_public_path__ + "media/images/leaflet/marker-icon-2x-black-06aca2684878f1f2f777bf043c1db242.png";